/** Parse the optional workshop kiosk controls without depending on the router. */
export function parseKioskParams(search = '') {
  const params = new URLSearchParams(search);
  const kiosk = ['1', 'true'].includes((params.get('kiosk') || '').toLowerCase());
  const rawTimer = params.get('timer');
  const timerMinutes = rawTimer && /^\d+$/.test(rawTimer) ? Number(rawTimer) : null;
  return {
    kiosk,
    timerMinutes: kiosk && timerMinutes >= 1 && timerMinutes <= 60 ? timerMinutes : null,
  };
}

/** The kiosk timer is deliberately advisory: it never changes arrangement state. */
export function kioskTimerState(startedAt, now, minutes) {
  if (!startedAt || !minutes) return { remainingSeconds: null, phase: 'idle' };
  const remainingSeconds = Math.max(0, Math.ceil((startedAt + minutes * 60_000 - now) / 1000));
  if (remainingSeconds === 0) return { remainingSeconds, phase: 'expired' };
  if (remainingSeconds <= 120) return { remainingSeconds, phase: 'nudge' };
  return { remainingSeconds, phase: 'running' };
}

export function formatKioskRemaining(seconds) {
  if (seconds == null) return '';
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
